import React, { useEffect, useState } from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

import { ReactComponent as Icon1 } from 'static/svg/matching-professionals-loading-icon-1.svg'
import { ReactComponent as Icon2 } from 'static/svg/matching-professionals-loading-icon-2.svg'
import { ReactComponent as Icon3 } from 'static/svg/matching-professionals-loading-icon-3.svg'
import { ReactComponent as Icon4 } from 'static/svg/matching-professionals-loading-icon-4.svg'
import { ReactComponent as Icon5 } from 'static/svg/matching-professionals-loading-icon-5.svg'

const icons = [Icon1, Icon2, Icon3, Icon4, Icon5]

export function Loading(): JSX.Element {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % icons.length)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const CurrentIcon = icons[index]

  return (
    <S.LoadingContainer>
      <S.LoadingIconWrapper>
        <CurrentIcon />
      </S.LoadingIconWrapper>

      <Typography
        variant='header3'
        weight='bolder'
        center
      >
        Buscando os melhores
        <br />
        psicólogos para você
      </Typography>

      <Typography
        center
        variant='content2'
      >
        Aguarde, isso pode levar alguns segundos.
      </Typography>
    </S.LoadingContainer>
  )
}
